import { tick } from 'svelte';
import { get } from 'svelte/store';

import { JUMP_TYPE_ENUM } from '../enums';
import { TechBtnId } from '../enums/track';
import {
    activityId,
    isJumpOneLink,
    isLoading,
    pageId,
    startTime
} from '../store/index';

import { getOnelinkUrl } from './onelink';
import { isMsiPage } from './pageType';
import { trackEvent } from './track';

import { pageLeave } from '@/utils/fmpTrack';
import { getH5creditCardBaseUrl } from '@/utils/getH5cardLink';
import url from '@/utils/url';

export const getH5CreditCardUrl = (
    params: Record<string, string | number> = {}
) => {
    const baseUrl = getH5creditCardBaseUrl();
    const resource = url.get('resource') || window.adv?.getChannelEnv();
    const parseQuery = url.pureParseQuery();

    return url.buildUrl(baseUrl, {
        ...parseQuery,
        resource,
        pageId: get(pageId),
        fromPage: isMsiPage() ? 'web-marketing' : 'web2app',
        activityId: get(activityId),
        fromPageId: window?.__PAGE_CONFIG__?.trackingPageId || '',
        ...params
    });
};

export const JumpLink = async (
    jumpType = JUMP_TYPE_ENUM.TO_H5CREDITCARD
): Promise<boolean> => {
    try {
        isJumpOneLink.set(true);
        await tick();

        if (jumpType === JUMP_TYPE_ENUM.TO_H5CREDITCARD) {
            const link = getH5CreditCardUrl();

            if (!link) return false;

            trackEvent(TechBtnId.JUMP, { url_type: 'creditcard' });
            trackEvent('fin_credit_abroad_apply_bureau_time_sw', {
                stay_time: Date.now() - get(startTime)
            });

            const preloader = window.preloader as {
                shouldShowIframe?: () => boolean;
                showIframe?: () => boolean;
            };

            if (
                preloader?.shouldShowIframe?.() &&
                preloader.showIframe?.()
            ) {
                return true;
            }

            isLoading.set(false);
            pageLeave();
            window.location.href = link;

            return true;
        }

        const link = getOnelinkUrl();

        trackEvent(TechBtnId.JUMP, { url_type: 'onelink' });

        if (link) {
            isLoading.set(false);
            pageLeave();
            window.location.href = link;

            return true;
        }

        return false;
    } catch (error) {
        console.error('JumpLink error:', error);

        return false;
    }
};

export const jumpToOnelink = async () => {
    await JumpLink(JUMP_TYPE_ENUM.TO_WEB2APP);
};
